<template>
  <text-area-input-modal
    ref="input"
    @selectedElement="propagateChange"
    :title="title"
    :student="studentName"
    :byDefault="state"
    :edit="edit"
  />
</template>
<script>
import BasicInputModal from './BasicInputModal.vue'
import TextAreaInputModal from '@/components/diaryElements/TextAreaInputModal.vue'

export default {
  components: { BasicInputModal, TextAreaInputModal },
  props: {
    title: {
      type: String,
      default: () => 'Mensaje'
    },
    studentName: {
      type: String,
      default: () => 'Todos'
    },
    student: {
      type: Object,
      default: () => ({ name: '' })
    },
    byDefault: {
      type: String,
      default: () => ''
    },
    edit: {
      type: Boolean,
      default: () => false
    }
  },
  created: function () {
    this.state = !this.byDefault ? this.byDefault : ''
    if (this.student && this.student.message) this.state = this.student.message
  },
  data: () => ({
    enabled: true,
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
    },
    propagateChange: function ({item}) {
      this.state = item
      this.$emit('updatedElement', { message: this.state })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/MessageTextArea.vue